import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class CountrySearchParams extends SearchParamsBase {
  initialize() {
    this.Name = '';
    this.Code = '';
    this.SelectedOfficeIds = [];
    this.SelectedEvaluatorOfficeIds = [];
    this.ClientBillingCurrencyId = '';
    this.EvaluatorCurrencyId = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'Name', label: 'Country name', className: 'col-3', type: InputTypesEnum.Text },
    { fieldName: 'Code', label: 'Code', className: 'col-2', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Sales/FW Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedEvaluatorOfficeIds',
      label: 'Evaluator Payment Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'ClientBillingCurrencyId',
      label: 'Client Billing Currency',
      className: 'col-4',
      type: InputTypesEnum.CurrencySelect,
    },
    {
      fieldName: 'EvaluatorCurrencyId',
      label: 'Evaluator Fee Currency',
      className: 'col-4',
      type: InputTypesEnum.CurrencySelect,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'CountrySearchParams';

  static defaultOfficeId = '';

  static ConvertToJSON(originalSearchItem) {
    let correctedSearchItem = { ...originalSearchItem };

    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }
}
